<script setup>
import { onBeforeMount } from 'vue';
import { resourceV2 } from '@/composables/resource';
import { useStore } from '@/store';

import SellerProfileForm from '@/components/Secondary/Marketplace/SellerProfileForm.vue';
import SideNav from '@/views/marketplace/_helpers/layout/SideNav.vue';

const store = useStore();
const seller = resourceV2({
    url: `/api/marketplace/sellers/${store.state.user.id}`,
});

onBeforeMount(() => seller.fetch());
</script>

<template>
    <layout-main>
        <head-title value="Edit Marketplace Profile" />
        <SideNav />
        <layout-content>
            <content-header hide-border>
                <top-nav>
                    <top-nav-back />

                    <top-nav-title>Edit Seller Profile</top-nav-title>
                </top-nav>
            </content-header>
            <content-body>
                <div v-if="seller.loadState === 'ready'" class="px-4 py-4">
                    <SellerProfileForm :profile="seller.data.profile" />
                </div>

                <app-layout-skeleton v-else-if="seller.loadState === 'loading'" />
                <app-error-not-found v-else-if="seller.loadState === 'missing'" />
                <app-error-default v-else-if="seller.loadState === 'error'" />
            </content-body>
        </layout-content>
    </layout-main>
</template>
